/**
 * 1品ごとの運送料の保証金額を自動設定するための条件群です。
 * 補償対象の判定は 荷主コード × 表紙コード × 請求内訳コード で行う（請求運送料計算 参照）。
 * intellisenseで具体的な数字を表示したい場合は、こちらを使わずに as const を変数に付与してください
 *
 * TODO: 補償条件はマスタテーブル化が必要（m_unsoryo_hosyo 等）。
 *   - 顧客側で運用追加できず、追加依頼のたびにコード変更＋リリースが発生している（KAIROS-1068 / KAIROS-1080）
 *   - 適用日が無いため、過去データの再計算で遡及的に金額が変わるリスクあり（KAIROS-1088 で類似事象発生済）
 *   - マスタ化＋適用日対応は別タスクで起票する
 */
export interface 運送料保証条件 {
  荷主コード: string
  表紙: {
    [表紙名: string]: {
      コード: string
      請求内訳コード: string
      /**
       * 参考情報。導入時（KIROS_DEV-175, 2022-10）から判定ロジックでは未使用で、値は実データと乖離している。
       * 例: ジャーム粕の実パターンは 5020 / 6001 / 6002（2026-07 時点。5010 は存在しない）
       */
      パターンコード: string
      /** 参考情報。判定ロジックでは未使用 */
      品コード: string
      保障数量: number
      保障金額: number
      保障単価?: number
    }
  }
}

// 昭和産業トン数保障計算用定数
export const 昭和産業 = {
  荷主コード: "32140",
  表紙: {
    ジャーム: {
      コード: "1",
      請求内訳コード: "1",
      パターンコード: "5000",
      品コード: "32720",
      保障数量: 10, //トン数
      保障金額: 11550,
    },
    ジャーム粕: {
      コード: "2",
      請求内訳コード: "1",
      パターンコード: "5010",
      品コード: "93273",
      保障数量: 8, //トン数
      保障金額: 23120,
    },
    ジャームダンプ: {
      コード: "1",
      請求内訳コード: "2",
      パターンコード: "5000",
      品コード: "32720",
      保障数量: 10, //トン数
      保障金額: 30000,
    },
  },
} as const

const unsoryoHosyo = {
  昭和産業,
}

export default unsoryoHosyo
